module.exports = __webpack_public_path__ + "explore/images/eoy/rainbow-2x.389370fef30b9be6a52db70569872707.png";